import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from '../locales/en.json'
import ru from '../locales/ru.json'
import de from '../locales/de.json'
import es from '../locales/es.json'
import tr from '../locales/tr.json'
import hr from '../locales/hr.json'
import cs from '../locales/cs.json'

Vue.use(VueI18n)

const messages = {
  en: en,
  ru: ru,
  de: de,
  es: es,
  tr: tr,
  hr: hr,
  cs: cs
}

function getLocale() {
  const storedLang = localStorage.getItem('user-locale')
  if (storedLang && messages[storedLang]) {
    return storedLang
  }

  const browserLang = navigator.languages ? navigator.languages[0] : navigator.language
  if (browserLang && messages[storedLang]) {
    return browserLang.split('-')[0]
  }

  return 'en'
}

const i18n = new VueI18n({
    locale: getLocale(),
    fallbackLocale: 'en',
    globalInjection: true,
    messages: messages
  })

export default i18n
